import script from "./weekSlider.vue?vue&type=script&setup=true&lang=js"
export * from "./weekSlider.vue?vue&type=script&setup=true&lang=js"

import "./weekSlider.vue?vue&type=style&index=0&id=822d0af0&scoped=true&lang=scss"

import exportComponent from "/home/steffen/Projekte/clubadmin/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-822d0af0"]])

export default __exports__